import { SVG } from '../svg';
import { IconProps } from '../types';

export function MoonIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
    </SVG>
  );
}
